/* Carga diferida de videos: el video empieza a descargarse y a reproducirse
   cuando el cliente se acerca a el, sin que tenga que tocar nada.
   Uso: <video data-lazy-video autoplay loop muted playsinline preload="none">
          <source data-src="URL.mp4" type="video/mp4">
        </video> */
(function () {
  function loadVideo(video) {
    if (video.getAttribute('data-lazy-loaded')) return;
    video.setAttribute('data-lazy-loaded', '1');
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
      sources[i].removeAttribute('data-src');
    }
    if (video.getAttribute('data-src')) {
      video.src = video.getAttribute('data-src');
      video.removeAttribute('data-src');
    }
    video.load();
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  function init() {
    var videos = document.querySelectorAll('video[data-lazy-video]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < videos.length; i++) loadVideo(videos[i]);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            loadVideo(entry.target);
          }
        });
      },
      { rootMargin: '300px 0px' }
    );
    for (var j = 0; j < videos.length; j++) observer.observe(videos[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
